'use client';

import { MatchSide } from '@/components/constants/types';
import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';
import { useScoreCard } from '@/contexts/ScoreCardProvider';

interface ConfirmUndoRetirementModalProps {
	setShowModal: (showModal: boolean) => void;
	gameNumber: string;
	team: MatchSide;
	matchId: string;
}

export const ConfirmUndoRetirementModal = ({ setShowModal, gameNumber, team, matchId }: ConfirmUndoRetirementModalProps) => {
	const { saveRetireScores } = useScoreCard();

	const handleUndo = () => {
		saveRetireScores(matchId, gameNumber, team, 'UNDO_RET');
		setShowModal(false);
	};

	const handleCancel = () => {
		setShowModal(false);
	};

	return (
		<ModalWrapper
			overlayClassName="z-10"
			className="max-w-[500px]"
			title="Confirm Undo Retirement"
			onClose={() => setShowModal(false)}
			closeOnOutsideClick
		>
			<div className="flex flex-col gap-2 py-5">
				<p className="text-sm font-medium">You are removing the retirement from this game. Are you sure you want to proceed?</p>
			</div>
			<ActionButtons
				className="flex justify-end gap-3"
				closeButtonClassName="w-32"
				submitButtonClassName="w-32"
				onClose={handleCancel}
				onSubmit={handleUndo}
				submitButtonText="Undo"
				closeButtonText="Cancel"
				submitButtonDisabled={false}
			/>
		</ModalWrapper>
	);
};
